import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['tab', 'panel']
    static classes = ['activeTab', 'activePanel']

    select (e) {
        for (let i = 0; i < this.panelTargets.length; i++) {
            const visible = this.tabTargets[i] === e.target;
            this.panelTargets[i].classList.toggle(this.activePanelClass, visible);
            this.panelTargets[i].setAttribute('aria-hidden', visible ? '' : 'true');
            this.tabTargets[i].classList.toggle(this.activeTabClass, visible);
            this.tabTargets[i].setAttribute('aria-selected', visible ? 'true' : '');

            if (!visible) {
                this.#stopVideo(this.panelTargets[i]);
            }
        }
    }

    #stopVideo(el) {
        el.querySelectorAll('iframe').forEach((iframe) => {
            iframe.src += '';
        });

        el.querySelectorAll('video, audio').forEach((video) => {
            video.pause();
        });
    }
}
